import { render } from "./ConfirmationModalNewStyle.vue?vue&type=template&id=63c519b7&scoped=true"
import script from "./ConfirmationModalNewStyle.vue?vue&type=script&lang=js"
export * from "./ConfirmationModalNewStyle.vue?vue&type=script&lang=js"

import "./ConfirmationModalNewStyle.vue?vue&type=style&index=0&id=63c519b7&scoped=true&lang=css"

import exportComponent from "/builds/ser-kso/wz-case-form-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63c519b7"]])

export default __exports__